import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9ba084e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "url-parser-container",
  "element-loading-text": "解析中，请稍候..."
}
const _hoisted_2 = {
  key: 0,
  class: "error-state"
}

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { parseCourseUrl } from '@/api/common'
import { ERR_SUCCESS } from '@/api/config'
import ResolveUrlList from '@/views/resolve/ResolveUrlList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResolveMain',
  props: {
    selectedResolveData: {}
  },
  setup(__props: any) {

const router = useRouter()
const inputUrl = ref(router.currentRoute.value.query.url || '')
const isLoading = ref(false)
const parseError = ref(false)

// eslint-disable-next-line no-undef
const props = __props

const resolveData = ref(props.selectedResolveData)

async function parseUrl () {
  const urlPattern = /https?:\/\/[^\s]+/
  const url = inputUrl.value.match(urlPattern)

  if (!url) {
    return
  }

  isLoading.value = true
  parseError.value = false
  resolveData.value = null

  try {
    const { code, result } = await parseCourseUrl({ url: url[0] })

    if (code === ERR_SUCCESS && result) {
      resolveData.value = {
        url: result.url,
        title: result.title,
        author: JSON.parse(result.resolve_result).author,
        course: JSON.parse(result.resolve_result).course.split('|'),
        fileList: result.resolve_url_resolve
      }
    } else {
      parseError.value = true
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    parseError.value = true
  } finally {
    isLoading.value = false
  }
}

watch(inputUrl, (newValue) => {
  if (newValue === '') {
    resolveData.value = null
    parseError.value = false
  }
})

watch(() => props.selectedResolveData, (newData) => {
  resolveData.value = newData
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Link = _resolveComponent("Link")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tag, null, {
      default: _withCtx(() => [
        _createTextVNode("国家智慧中小学云平台-课程教学")
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, null, {
      default: _withCtx(() => [
        _createTextVNode("部优精品课-微课展示")
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, null, {
      default: _withCtx(() => [
        _createTextVNode("皖教云-资源专区")
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, null, {
      default: _withCtx(() => [
        _createTextVNode("皖教云-活动评选")
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, null, {
      default: _withCtx(() => [
        _createTextVNode("山东省优课资源-精品优课")
      ]),
      _: 1
    }),
    _createVNode(_component_el_tag, null, {
      default: _withCtx(() => [
        _createTextVNode("北京市空中课堂-课程教学")
      ]),
      _: 1
    }),
    _createVNode(_component_el_input, {
      modelValue: inputUrl.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputUrl).value = $event)),
      clearable: "",
      placeholder: "粘贴url地址，目前支持以上平台资源 ……"
    }, {
      append: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "large",
          onClick: parseUrl
        }, {
          default: _withCtx(() => [
            _createTextVNode("解析")
          ]),
          _: 1
        })
      ]),
      prepend: _withCtx(() => [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_Link)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (parseError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_alert, {
            description: "未能及时获取到解析到数据，请刷新查看最近解析记录，如果没有可稍后再试。",
            title: "解析失败",
            type: "error"
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(ResolveUrlList, { resolveData: resolveData.value }, null, 8, ["resolveData"])
  ])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})